export interface ArticleData {
  id: string;
  title: string;
  content: string;
  author: string;
  date: string;
  category: string;
  tags: string[];
  summary: string;
  coverImage: string;
  relatedIds: string[];
}

export const articles: ArticleData[] = [
  {
    id: "article-1",
    title: "2026年暑期档必看十大电影推荐",
    content: `<p>随着2026年暑期档的临近，各大影视公司纷纷亮出了自己的王牌作品。从国产科幻巨制到温情文艺片，从动画大片到动作爽片，今年的暑期档可谓精彩纷呈。以下是我们精心挑选的十部必看影片，每一部都值得你走进影院——当然，如果你更喜欢在家观影，木瓜影视也为你准备好了高清资源。</p>
    <h3>1. 流浪地球3 - 科幻巅峰再临</h3>
    <p>郭帆导演的流浪地球系列第三部，延续了前两部的宏大世界观。本片讲述了地球在脱离太阳系后的全新冒险，视觉效果再度升级，IMAX版本更是震撼人心。吴京、刘德华、李雪健等实力派演员的加盟，让这部科幻大片的情感内核更加饱满。</p>
    <h3>2. 哪吒之魔童闘海2 - 国漫新高度</h3>
    <p>饺子导演耗时五年打造的续作，延续了前作的神话世界观。本片在动画技术上有了巨大突破，无论是人物表情的细腻程度还是战斗场面的流畅度，都达到了国际一流水准。故事更加深刻，探讨了命运与选择、亲情与牺牲的永恒主题。</p>
    <h3>3. 封神第三部 - 史诗终章</h3>
    <p>乌尔善导演的封神三部曲迎来终章。牧野之战将全面爆发，封神榜上最后一个名字也将揭晓。黄渤、费翔、李雪健等演员的精彩演绎，配合顶级的视效团队，将为观众呈现一场前所未有的神话史诗。</p>
    <h3>4. 满江红2 - 悬疑再升级</h3>
    <p>张艺谋导演延续了前作的悬疑风格，将故事背景推向了更加复杂的历史节点。沈腾与易烊千玺再度联手，在一场惊天阴谋中寻找真相。影片融合了历史与悬疑元素，节奏紧凑，反转不断。</p>
    <h3>5. 狂飙2：暗流 - 扫黑新篇章</h3>
    <p>尽管是一部剧集而非电影，但狂飙2的期待值丝毫不亚于任何大片。张译与张颂文的再度合作，将扫黑除恶的故事推向新高度。剧情更加烧脑，人物更加立体。</p>
    <p>以上五部作品只是暑期档的冰山一角，还有更多精彩内容等待你的发现。记得锁定木瓜影视，我们将在第一时间为你带来高清资源。</p>`,
    author: "影视小编",
    date: "2026-07-28",
    category: "movie",
    tags: ["暑期档", "电影推荐", "热门影视"],
    summary: "2026年暑期档强势来袭，国产科幻、动画、史诗大片齐聚。本文为你盘点暑期档最值得期待的十部影片，每部都是诚意之作。",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20summer%20movie%20posters%20collage%20with%20cinema%20atmosphere%2C%20warm%20golden%20lighting%2C%20film%20reels%2C%20dramatic%20composition%2C%20dark%20background%20with%20spotlight&width=1200&height=630&seq=article-cover-01&orientation=landscape",
    relatedIds: ["movie-1", "movie-3", "movie-4"],
  },
  {
    id: "article-2",
    title: "古装剧为什么越来越受欢迎？解析国风影视热潮",
    content: `<p>近年来，古装剧市场持续升温。从《庆余年》到《唐朝诡事录》，从《长安十二时辰》到《梦华录》，一部部制作精良的古装剧不断刷新着观众的审美。那么，古装剧为何能在竞争激烈的影视市场中脱颖而出？本文将从多个维度为你解析这场国风热潮。</p>
    <h3>一、文化自信的回归</h3>
    <p>随着国家实力的增强和文化自信的提升，越来越多的观众开始关注并热爱中国传统文化。古装剧作为传统文化的载体之一，自然而然地获得了更多关注。精美的服化道、考究的历史细节、典雅的古诗词引用，都让观众在追剧的同时感受到了中华文化的魅力。</p>
    <h3>二、制作水平的飞跃</h3>
    <p>从早期的粗糙布景到今天堪比电影的画面质感，国产古装剧的制作水平经历了质的飞跃。导演们更加注重光影的运用、色彩的搭配和场景的真实感，使得每一帧画面都如同一幅精美的中国画。服装设计也更加考究，从面料到纹样都经得起推敲。</p>
    <h3>三、剧情创新的突破</h3>
    <p>现代古装剧不再是简单的宫斗和权谋。创作者们开始融入悬疑、科幻甚至喜剧等多元元素，使得古装剧的类型边界不断拓宽。《唐朝诡事录》将探案与古装完美融合，《庆余年》则大胆地加入了穿越和科幻的设定，这些创新让古装剧焕发出新的生命力。</p>
    <h3>四、演员阵容的强大</h3>
    <p>越来越多的实力派演员加入到古装剧的拍摄中。陈道明、张若昀、杨志刚等演员的精彩演绎，为古装剧注入了深厚的人文内涵。他们不仅仅是表演，更是在传承一种文化精神。</p>
    <h3>五、国际影响力的提升</h3>
    <p>优秀的古装剧不仅在国内受欢迎，在海外也收获了大量粉丝。Netflix、Disney+等国际平台纷纷购买国产古装剧的海外版权，让全世界观众都能感受到中国文化的独特魅力。</p>
    <p>古装剧的崛起不是偶然，而是中国文化软实力提升的必然结果。在木瓜影视，你可以随时重温这些经典古装剧，感受国风之美。</p>`,
    author: "文化观察员",
    date: "2026-07-25",
    category: "tv",
    tags: ["古装剧", "国风", "文化现象"],
    summary: "古装剧市场持续升温，从文化自信、制作水平、剧情创新、演员阵容到国际影响力，五大因素深度解析这场国风影视热潮。",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20elegant%20scene%20with%20ancient%20Chinese%20costumes%2C%20palace%20architecture%2C%20soft%20golden%20lantern%20light%2C%20misty%20atmosphere%2C%20cinematic%20composition&width=1200&height=630&seq=article-cover-02&orientation=landscape",
    relatedIds: ["tv-1", "tv-3"],
  },
  {
    id: "article-3",
    title: "国产动画崛起：从《大圣归来》到《哪吒2》的十年之路",
    content: `<p>十年前，《大圣归来》以黑马之姿横空出世，让国人看到了国产动画的无限可能。十年后的今天，《哪吒之魔童闘海2》再次刷新票房纪录，标志着国产动画进入了一个全新的黄金时代。这十年间，国产动画经历了怎样的蜕变？</p>
    <h3>破冰期：《大圣归来》打开一扇窗</h3>
    <p>2015年，《大圣归来》以近10亿的票房成绩，打破了国产动画"低幼化"的刻板印象。影片精良的制作、成熟的叙事和浓厚的中国风，让观众第一次意识到：国产动画也可以很好看。这部作品被誉为国产动画复兴的开端。</p>
    <h3>探索期：百花齐放的尝试</h3>
    <p>此后，《大鱼海棠》《大护法》《白蛇：缘起》等一系列风格各异的作品相继问世。有的追求画风美学，有的注重思想深度，有的探索爱情主题。虽然并非每部都获得商业上的巨大成功，但它们的出现丰富了国产动画的类型维度。</p>
    <h3>爆发期：《哪吒》开启新纪元</h3>
    <p>2019年，《哪吒之魔童降世》以超过50亿的票房震惊业界。这部作品证明了中国动画电影完全可以与好莱坞动画一较高下。它不仅在技术层面达到了新高度，更在故事内核上完成了对传统神话的现代诠释。</p>
    <h3>成熟期：从单品爆款到产业集群</h3>
    <p>到了2026年，国产动画已经形成了完整的产业链。从原创IP开发到衍生品运营，从国内发行到海外输出，整个行业体系日趋完善。更重要的是，越来越多的年轻动画人才涌现出来，为行业注入了新鲜血液。</p>
    <h3>展望未来</h3>
    <p>随着AI技术、实时渲染等新技术的应用，国产动画的制作效率和质量都将进一步提升。我们有理由相信，下一个十年，中国动画将在世界舞台上绽放更加耀眼的光芒。木瓜影视也将持续关注并收录优秀的国产动画作品。</p>`,
    author: "动画爱好者",
    date: "2026-07-20",
    category: "anime",
    tags: ["国产动画", "国漫崛起", "行业分析"],
    summary: "从《大圣归来》到《哪吒2》，国产动画用十年时间实现了质的飞跃。回顾这条崛起之路，展望未来的无限可能。",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20animation%20evolution%20collage%20from%20traditional%20to%20modern%203D%20style%2C%20colorful%20vibrant%20characters%2C%20dynamic%20composition%2C%20dark%20background%20with%20golden%20accents&width=1200&height=630&seq=article-cover-03&orientation=landscape",
    relatedIds: ["movie-3"],
  },
  {
    id: "article-4",
    title: "如何挑选适合自己的纪录片？五大类型帮你找到心头好",
    content: `<p>纪录片是了解世界的一扇窗。但面对海量的纪录片资源，很多人不知道该从何看起。这篇文章将按照五大类型为你梳理推荐，帮你快速找到适合自己的纪录片。</p>
    <h3>一、美食类纪录片</h3>
    <p>以《舌尖上的中国》为代表的美食纪录片，不仅仅是展示美食本身，更是在讲述食物背后的人间烟火。这类纪录片节奏舒缓，画面精美，适合在放松的时候观看。看着热气腾腾的美食，仿佛能闻到饭菜的香气。木瓜影视收录了《舌尖上的中国》全系列以及《风味人间》《人生一串》等经典美食纪录片。</p>
    <h3>二、自然地理类纪录片</h3>
    <p>《航拍中国》《第三极》《美丽中国》等作品，用镜头记录了中国大地的壮美景色。从青藏高原到南海岛礁，从东北雪原到西双版纳雨林，每一帧画面都美得让人窒息。这类纪录片适合想要放松心情、开阔眼界的观众。</p>
    <h3>三、历史人文类纪录片</h3>
    <p>《河西走廊》《大明宫》《故宫100》等历史纪录片，用严谨的态度和精美的画面还原了历史的真实面貌。观看这类纪录片，就像是在上一堂生动的历史课，让你在不知不觉中收获知识。</p>
    <h3>四、社会纪实类纪录片</h3>
    <p>《人间世》《我在故宫修文物》《最后的棒棒》等作品，聚焦普通人的生活与情感。它们没有宏大的叙事，却用最真实的故事打动了无数观众的心。这类纪录片往往能引发深层次的思考。</p>
    <h3>五、科技探索类纪录片</h3>
    <p>《创新中国》《超级工程》等科技纪录片，展现了中国在科技领域的飞速发展。从高铁到航天，从深海探测到人工智能，每一个进步都让人热血沸腾。</p>
    <p>无论你是哪种类型的纪录片爱好者，在木瓜影视都能找到属于你的那份精彩。现在就打开纪录片频道，开启你的知识之旅吧。</p>`,
    author: "纪录片达人",
    date: "2026-07-18",
    category: "documentary",
    tags: ["纪录片", "推荐指南", "知识科普"],
    summary: "纪录片种类繁多不知从何看起？从美食、自然、历史、社会到科技，五大类型精选推荐，总有一款适合你。",
    coverImage: "https://readdy.ai/api/search-image?query=Documentary%20film%20concept%20with%20camera%20lens%2C%20world%20map%2C%20nature%20and%20city%20elements%2C%20warm%20cinematic%20lighting%2C%20educational%20atmosphere%2C%20dark%20background&width=1200&height=630&seq=article-cover-04&orientation=landscape",
    relatedIds: ["doc-1", "doc-2"],
  },
];